import { useDropzone } from 'react-dropzone';

const CardDocsCargarReclamo = ({ reclamoId, docKey, title, maxFiles, archivos, setArchivos }) => {
  const currentFiles = archivos[docKey] || [];
  const onDrop = acceptedFiles => {
    if (currentFiles.length + acceptedFiles.length > maxFiles) {
      alert(`Solo se permiten ${maxFiles} archivos para este documento.`);
      return;
    }
    setArchivos(prev => ({
      ...prev,
      [docKey]: [...prev[docKey], ...acceptedFiles],
    }));
  };
  const removeFile = file => {
    setArchivos(prev => ({
      ...prev,
      [docKey]: prev[docKey].filter(f => f !== file),
    }));
  };
  const { getRootProps, getInputProps } = useDropzone({ onDrop });
  return (
    <div className='card-doc'>
      <p className='card-doc-title'>{title}</p>
      <div {...getRootProps()} style={{ textAlign: 'center', cursor: 'pointer' }}>
        <input {...getInputProps()} />
        <i className='bi bi-cloud-arrow-up-fill' style={{ fontSize: 26, color: '#458DF9' }}></i>
        <p style={{ fontSize: 13 }}>Arrastrá o hacé clic para subir</p>
      </div>
      {currentFiles.length > 0 && (
        <ul className='lista-archivos'>
          {currentFiles.map((file, index) => (
            <li key={index}>
              <span title={file.name}>{file.name}</span>
              <i className='bi bi-x' onClick={() => removeFile(file)}></i>
            </li>
          ))}
        </ul>
      )}
      <p className='center text-danger'>Max: {maxFiles}</p>
    </div>
  );
};

export default CardDocsCargarReclamo;
